import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import i18n from '../../../../../common/i18n';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetTeamStatistics } from '../../../sportradar-widgets/SrWidgetTeamStatistics';

function BetradarMTTeamStatistics({ matchId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper title={i18n('betradarMT.statisticTab.teamHome')}>
                <SrWidgetTeamStatistics matchId={matchId} team={'home'} />
            </WidgetWrapper>
            <WidgetWrapper title={i18n('betradarMT.statisticTab.teamAway')}>
                <SrWidgetTeamStatistics matchId={matchId} team={'away'} />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTTeamStatistics;
